import { useContext } from "react";
import styled from "styled-components";
import { EventContext } from "context";
import { Header, Main, Footer } from "Layout";

type PrimaryTemplateProps = {
  preCampaign?: boolean;
  registered?: boolean;
  postCampaign?: boolean;
  // header
  showHeader?: boolean;
  // main
  heroContent?: React.ReactNode;
  heading?: string;
  subHeading?: string;
  body?: string;
  children?: React.ReactNode;
  flexGrow?: boolean;
  // site footer
  showFooter?: boolean;
  zip?: string;
};

export const PrimaryTemplate = ({
  preCampaign,
  registered,
  postCampaign,
  // header
  showHeader,
  // main
  heroContent,
  heading,
  subHeading,
  body,
  children,
  flexGrow,
  // site footer
  showFooter,
  zip,
}: PrimaryTemplateProps) => {
  const { event } = useContext(EventContext);

  return (
    <SiteContainer>
      {event.test && <TestEventBanner>Viewing Test Event</TestEventBanner>}

      <Header showHeader={showHeader} />

      <Main
        heroContent={heroContent}
        heading={heading}
        subHeading={subHeading}
        body={body}
        children={children}
        flexGrow={flexGrow}
      />

      <Footer
        showFooter={showFooter}
        preCampaign={preCampaign}
        registered={registered}
        postCampaign={postCampaign}
        zip={zip}
      />
    </SiteContainer>
  );
};

const SiteContainer = styled.div`
  flex-direction: column;
  margin: 0 auto;
  min-height: 100vh;
  position: relative;
  width: 100%;
  display: flex;
  position: relative;
`;

const TestEventBanner = styled.div`
  background-color: #ff003b;
  color: #ffffff;
  font-size: 12px;
  text-align: center;
  padding: 3px 10px;
`;
